<script>
    import { UserData } from "./UserStore.js";
    import UserActions from "./UserActions.svelte";
    import { SendRequest } from "./APIService";
    import { showModal } from "./Modal";
    import PrivateUserNews from "./PrivateUserNews.svelte";

    let keys = [];
    let values = [];

    $: {
        keys = [];
        values = [];
        for (const [key, value] of Object.entries($UserData)) {
            keys = [...keys, key];
            values = [...values, value];
            console.log(`${key}: ${value}`);
        }
    }

    function BanDevice() {
        SendRequest(
            "BanDevice",
            "POST",
            "deviceId=" + $UserData.activeDeviceId,
            () => {
                showModal("ban", "Done", "OK");
                RefreshUser();
            },
        );
    }

    function UnbanDevice() {
        SendRequest(
            "UnbanDevice",
            "POST",
            "deviceId=" + $UserData.activeDeviceId,
            () => {
                showModal("Unban", "Done", "OK");
                RefreshUser();
            },
        );
    }

    function RefreshUser() {
        SendRequest("GetUser", "POST", "userId=" + $UserData.id, (response) =>
            apiData.set(response),
        );
    }
</script>

<br />

{#if keys.length > 0}
    <UserActions />

    <div class="card col-md-12">
        <div class="card-header">
            <h3>User Data</h3>
        </div>
        <div class="card-body">
            <table class="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th scope="col">Item</th>
                        <th scope="col">Value</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Ban Status -->
                    <tr class="table-light">
                        <td><strong>User Ban</strong></td>
                        <td>
                            {#if $UserData.isUserBanned}
                                <span class="badge bg-danger">🔴 Banned</span>

                                {#if $UserData.userBanTime}
                                    <br />
                                    <small>
                                        Until:
                                        {new Date(
                                            $UserData.userBanTime,
                                        ).toLocaleString()}
                                    </small>
                                {/if}
                            {:else}
                                <span class="badge bg-success">🟢 Active</span>
                            {/if}
                        </td>
                    </tr>

                    <tr class="table-light">
                        <td><strong>Device Ban</strong></td>
                        <td>
                            {#if $UserData.isDeviceIdBanned}
                                <span class="badge bg-danger">🔴 Banned</span>
                            {:else}
                                <span class="badge bg-success">🟢 Active</span>
                            {/if}
                        </td>
                    </tr>

                    <tr class="table-light">
                        <td><strong>Social Ban</strong></td>
                        <td>
                            {#if $UserData.isSocialBanned}
                                <span class="badge bg-danger">🔴 Banned</span>
                            {:else}
                                <span class="badge bg-success">🟢 Active</span>
                            {/if}
                        </td>
                    </tr>

                    {#each keys as prop, index (prop)}
                        {#if prop == "userVipBundle"}
                            <tr>
                                <td>{prop}</td>
                                <td>
                                    <p>{JSON.stringify(values[index])}</p>
                                </td>
                            </tr>
                        {/if}
                    {/each}

                    {#each keys as prop, index (prop)}
                        {#if prop != "userVipBundle" && prop != "isUserBanned" && prop != "isDeviceIdBanned" && prop != "isSocialBanned"}
                            <tr>
                                {#if prop == "activeDeviceId"}
                                    <td>{prop}</td>
                                    <td>
                                        <p>{JSON.stringify(values[index])}</p>

                                        <button
                                            class="btn btn-danger me-2"
                                            type="button"
                                            on:click={BanDevice}
                                        >
                                            Ban Device
                                        </button>

                                        <button
                                            class="btn btn-warning"
                                            type="button"
                                            on:click={UnbanDevice}
                                        >
                                            Unban Device
                                        </button>
                                    </td>
                                {:else}
                                    <td>{prop}</td>
                                    <td>{JSON.stringify(values[index])}</td>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
    </div>

    <PrivateUserNews />
{/if}

<style>
    .table td,
    .table th {
        word-wrap: break-word;
        min-width: 160px;
        max-width: 160px;
    }

    .card {
        margin: 5px;
    }
</style>
